class Article {
  id?: string;

  title?: string;

  // detail_info?: string; // 一覧表示では使わない
  description?: string;

  genres?: { key?: string }[];

  prices?: { key?: string }[];

  kinds?: { id: number; name: string }; // NOTE: kindsと複数形になっているが、実際は1つのみ

  charitable_gifts?: { key?: string }[];

  is_vol?: string;

  is_job?: string;

  main_pic_url?: string;

  large_pic_url?: string;

  medium_pic_url?: string;

  small_pic_url?: string;

  _modified_text_for_views?: { key?: string };

  end_of_pause_at?: string;

  deadline?: string;

  status?: Number;

  updated_at?: string;

  // 以下_modified_text_for_viewsの中身
  working_form_or_kind?: string;

  updated_date?: string;

  dates_or_terms?: string;

  frequents?: string;

  terms_or_periods?: string;

  member_activity_dates?: string;

  display_activity_locations?: string;

  display_activity_locations_small?: string;

  positions_and_targets?: string;

  positions_and_age_group?: string;

  working_form_slim_names?: string;

  // 浅い意思決定abテスト用。tag表示用text
  online_possibility?: string;

  characteristics?: string;

  job_characteristics?: string;

  job_types?: string;

  age_groups_characteristics?: string;

  atmospheres?: string;

  skills?: string;

  tags?: string;

  // user
  user?: {
    id?: number;
    name?: string;
    icon_url?: string;
    paid_plan_transactions?: {
      starts_at: string;
      expires_at: string;
      plan_grade: string;
    }[];
  };

  // promotions
  promotions?: any;

  // NOTE: data属性に埋め込むeコマース用のデータ
  gtm_ecommerce_data?: { [key: string]: any };

  constructor(props: Partial<Article>) {
    Object.assign(this, props);
    Object.entries(this._modified_text_for_views!).forEach(([key, value]) => {
      this[key] = value;
    });
  }

  // articleのカテゴリーを動的に表示するための配列
  static category_labels(): string[] {
    return [
      "display_activity_locations",
      "prices",
      "positions_and_age_group",
      "dates_or_terms",
      "frequents",
      "terms_or_periods",
      "member_activity_dates",
      "charitable_gifts",
    ];
  }

  // sp検索結果ページでは、意思決定のための情報量を増やす目的で別のカラムを使用する
  // PCページにも反映する場合、category_labels と共通化必要だが、未定のため命名など保留(2022/10/18時点)
  static category_labels_for_sp(): string[] {
    return [
      "display_activity_locations_small",
      "prices",
      "positions_and_age_group",
      "dates_or_terms",
      "frequents",
      "terms_or_periods",
      "member_activity_dates",
    ];
  }

  // category_labels_for_sp と同様
  tag_names_for_ab(): string[] {
    const online_status = ["online", "online_or_offline"].includes(
      this.online_possibility!
    )
      ? "リモート可"
      : "";
    const tag_names_str = this.is_vol!
      ? [
          online_status,
          this.characteristics!,
          this.age_groups_characteristics!,
          this.atmospheres!,
          this.skills!,
          this.tags!,
        ]
      : [
          online_status,
          this.job_characteristics!,
          this.job_types!,
          this.skills!,
          this.age_groups_characteristics!,
          this.tags!,
        ];
    return tag_names_str
      .join(",")
      .split(",")
      .filter((e) => e != "")
      .filter((e) => e.length <= 13)
      .slice(0, 5);
  }

  // category_labelsの要素を引数に取る
  static class_name(cat: string): string {
    if (
      cat == "display_activity_locations" ||
      cat == "display_activity_locations_small"
    ) {
      return "isGetActivityLocations";
    }

    if (cat == "positions_and_age_group") {
      return "isPositionsAndAgeGroup";
    }

    return `is_get_${cat}`.replace(/_(.)/g, (match, group) =>
      group.toUpperCase()
    ); // snake_caseからCamelCaseへ動的に変換
  }

  user_name(): string {
    return this.user!.name || "";
  }

  user_id(): number {
    return this.user!.id || "";
  }

  user_plan_name(): string {
    const current_plan_names =
      (this.user!.paid_plan_transactions || [])
        .filter(
          (t) =>
            new Date(t.starts_at) < new Date(Date.now()) &&
            new Date(Date.now()) < new Date(t.expires_at)
        )
        .map((t) => t.plan_grade) || [];
    let result: string;
    if (current_plan_names.includes("premium")) {
      result = "premium";
    } else if (current_plan_names.includes("lite")) {
      result = "lite";
    } else {
      result = "free";
    }
    return result;
  }

  category_names(cats: string): string {
    if (Object.keys(this._modified_text_for_views!).includes(cats)) {
      return this[cats];
    }
    return this[cats]
      ? this[cats]
          .map((obj) => obj.name)
          .slice(0, 3)
          .join("，")
      : "";
  }

  path(): string {
    const basePath = this.is_job
      ? `/job/articles/${this.id}`
      : `/articles/${this.id}`;
    return this.is_promotion()
      ? `${basePath}?via=promotion${this.id}`
      : basePath;
  }

  companies_path(company_name: string): string {
    // === LVJ 旧URL 暫定対応 開始 ===
    // NOTE: LVJ 旧URL運用中（pathname が `/companies/{name}` 始まり）は従来形式を返す。
    //       LVJ も subdomain 移行する際はこのブロックごと削除すれば良い。
    if (location.pathname.startsWith("/companies/")) {
      return `/companies/${company_name}/articles/${this.id}`;
    }
    // === LVJ 旧URL 暫定対応 終了 ===
    return `/articles/${this.id}`;
  }

  // ABテスト後にデザインが変わった場合は必要
  // new_contact_path(params: {key: string}): string {
  //   let query = '';
  //   if (params) {
  //     query = '?' + Object.keys(params).map(key => `${key}=${params.key}`).join('&');
  //   }
  //   return this.volunteer_or_job == 'job'
  //     ? `/job/articles/${this.id}/contacts/new${query}`
  //     : `/articles/${this.id}/contacts/new${query}`;
  // }

  bookmark_path(method: string): string {
    return method == "post"
      ? `/articles/${this.id}/bookmarks`
      : `/articles/${this.id}/bookmark`; // delete
  }

  is_promotion(): boolean {
    let judge = false;
    if (!this.promotions) {
      return judge;
    }
    // eslint-disable-next-line consistent-return
    this.promotions.forEach((ads_ticket) => {
      if (!ads_ticket!.begin_at) {
        return judge;
      }
      const begin_at = new Date(ads_ticket!.begin_at);
      const finish_at = new Date(ads_ticket!.finish_at);
      if (begin_at <= new Date() && finish_at >= new Date()) {
        judge = true;
      }
    });
    return judge;
  }

  is_closing(): boolean {
    return this.status === 3;
  }

  is_pausing(): boolean {
    return new Date(this.end_of_pause_at!) > new Date();
  }

  is_new_arrival(): boolean {
    const updated_at = new Date(this.updated_at!);
    updated_at.setDate(updated_at.getDate() + 7);
    const current_at = new Date();
    return updated_at > current_at;
  }

  deadline_text(): string | null {
    const deadline = new Date(this.deadline!);

    const current_date = new Date();
    const future_date = new Date();
    future_date.setDate(future_date.getDate() + 7);

    let deadline_text;
    if (
      this.deadline !== null &&
      deadline > current_date &&
      deadline < future_date
    ) {
      const days_left = Math.ceil(
        (deadline.getTime() - current_date.getTime()) / 86400000
      );
      deadline_text =
        days_left > 0 ? `締切${String(days_left)}日前` : "本日締切";
    }
    return deadline_text;
  }

  gtm_article_data(): { key?: string } {
    let status: string;
    if (this.is_pausing()) {
      status = "pausing";
    } else if (this.is_closing()) {
      status = "closing";
    } else {
      status = "publish";
    }

    let pid: number;
    if (this.user_plan_name() == "premium") {
      pid = 2;
    } else if (this.user_plan_name() == "lite") {
      pid = 1;
    } else {
      pid = 0;
    }
    const article_data = {
      id: this.id,
      "user-id": this.user_id,
      ad: this.is_promotion() ? 1 : 0,
      status,
      pid,
      VorJ: this.is_job ? "job" : "vol",
      kind: this.kinds?.id,
    };
    return Object.fromEntries(
      Object.keys(article_data).map((key) => [
        `data-gtm-${key}`,
        article_data[key],
      ])
    );
  }

  gtm_ecommerce_data_attributes(): { [key: string]: any } {
    const gtm_data = this.gtm_ecommerce_data || {};
    const result: { [key: string]: any } = {};

    Object.keys(gtm_data).forEach((key) => {
      const attrKey = `data-${key}`;
      result[attrKey] = gtm_data[key];
    });

    return result;
  }
}

export default Article;
